@if (info) {
    <div class="display-info-container">
        <div class="grid-wrapper">
            @for (row of info; track row; let index = $index) {
                <div class="row">
                    @for (cell of row; track cell) {
                        <div class="cell"
                             [style.grid-column]="index > 0 ? 'span ' + cell.span : 'auto'">
                            <div class="t4 c-primary-gray-800 no-wrap">{{ 'i18n_af_field#' + cell.label | translate }}</div>
                            <div class="t5 c-primary-gray-900 no-wrap"
                                 [class.w-fit-content]="cell.type === 'status' || cell.type === 'priority'"
                                 [class.crop-text]="!!cell.cropText"
                                 [matTooltip]="cell.cropText && cell.value || ''">
                                @if (cell.type === 'text') {
                                    {{ cell.value | translate }}
                                }
                                @if (cell.type === 'date-time') {
                                    {{ cell.value | date:'dd.MM.yyyy HH:mm:ss' }}
                                }
                                @if (cell.type === 'money') {
                                    {{ 'i18n_af_labelMoney' | translate:{money: (cell.value | tiynTenge | numberTriplesFormat)} }}
                                }
                                @if (cell.type === 'status') {
                                    <af-status [statusText]="cell.value" [status]="cell.statusStyle"/>
                                }
                                @if (cell.type === 'priority') {
                                    <af-priority [priorityLevel]="cell.value"/>
                                }
                            </div>
                        </div>
                    }
                </div>
            }
        </div>
    </div>
}
